import { render, staticRenderFns } from "./fundraiser_result.vue?vue&type=template&id=4359e71d&"
import script from "./fundraiser_result.vue?vue&type=script&lang=js&"
export * from "./fundraiser_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports